export default "__VITE_ASSET__ba2bf10c__"